import React, { Component, Fragment } from 'react';
import { ClipLoader, BarLoader } from 'react-spinners';
import axios from 'axios';
import ResourceItem from './ResourceItem';
import ResourceFilter from './ResourceFilter';
import PublicTagLinks from '../../PublicTagLinks';
import Pagination from 'react-js-pagination';
// import '../../sass/modules/pagination.scss';
import { Scrollbars } from 'react-custom-scrollbars';

const API_URL = process.env.REACT_APP_API_URL+'api/resources';
const INITIAL_STATE = {
	resources: [],
	next_page: API_URL,
	loading: false,
	filtered: false,
	init_load_more: false,
	pagination: [],
	resource: {
		title: '',
		type: 0,
		organisation_title: '',
		artsmark_partner: 0,
		support_send: 0,
		keystages: [],
		artform: 0,
		venue_name: '',
		postcode: '',
		status: 'active',
		sort: 'submitted',
		free: 0,
		visible: 1,
		page: 1
	}
};

class ResourceList extends Component {
	state = INITIAL_STATE;

	componentDidMount() {
		this.init();
		this.resourceFilter = React.createRef();
		this.scrollInto = React.createRef();
	}

	init() {
		if(!this.state.loading) {

			this.setState({
				loading: true
			});

			let conditions = {
				status: 'active',
				support_send: (this.props.support_send && this.props.support_send === 1)? 1: 0,
				free: (this.props.free && this.props.free === 1)? 1: 0,
				visible: this.state.resource.visible,
				page: this.state.resource.page
			};

			// let only_free_resources = this.props.free;
			// if(only_free_resources && only_free_resources === 1) {
			// 	conditions = {
			// 		status: 'active',
			// 		free: 1,
			// 		visible: this.state.resource.visible,
			// 		page: this.state.resource.page
			// 	}
			// }

			axios.post(API_URL+'/filter', conditions)
				.then(response => {
					const pagination = response.data.meta.pagination;
					const resources = response.data.data;

					if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
						this.setState({
							resources: resources,
							loading: false,
							pagination: pagination,
							init_load_more: true
						}, () => {
							const url = window.location.href;

							this.saveState(url, this.state.resources, this.state.resource.page, this.state.pagination);
							this.events();
						});
					} else {
						this.setState({
							resources: resources,
							loading: false,
							pagination: pagination,
							init_load_more: false
						}, () => {
							const url = window.location.href;

							this.saveState(url, this.state.resources, this.state.resource.page, this.state.pagination);
							this.events();
						});				
					}
				}).catch(error => {

					this.setState(prevState => ({
						...prevState,
						loading: false
					}));

					console.log(error);
				});
		}
	}

	events() {
		if (window.location.search.indexOf('page') > 0) {
			const url = new URL(window.location.href);
			const page = url.searchParams.get('page');

			axios.post(API_URL+'/filter', { 
					status: 'active',
					visible: 1,
					page: page,
				})
				.then(response => {
					const resources = response.data.data;
					const pagination = response.data.meta.pagination;

					this.setState(
						prevState => ({
							resources: resources,
							loading: false,
							pagination: pagination,
							init_load_more: false,
							resource: {
								...prevState.resource,
								page: parseInt(page)
							}
						}), () => {
							const url = window.location.href;

							this.saveState(url, this.state.resources, this.state.resource.page, this.state.pagination);
						}
					);
				});
		}

		window.addEventListener("popstate", (e) => {
			if (e.state !== null) {
				this.setState(
					prevState => ({
						...prevState,
						resources: e.state.filtersHtml,
						resource: {
							...prevState.resource,
							page: e.state.page
						},
						pagination: e.state.pagination
					})
				);				
			}
		});
	}

	onClearFilter = () => {
		this.setState(INITIAL_STATE, () => {
			this.init();
			this.resourceFilter.current.getArtformTypes();
		});
	};

	onFilteredResults = (props) => {
		this.setState({
			resources: [],
			init_load_more: false,
			loading: true,
			filtered: true,
			resource: {
				keyword: props.resource.keyword,
				type: props.resource.type,
				organisation_title: props.resource.organisation_title,
				support_send: props.resource.support_send,
				keystages: props.resource.keystages,
				postcode: props.resource.postcode,
				artform: props.resource.artform,
				distance: props.resource.distance,
				sort: props.resource.sort,
				free: props.resource.free,
				status: this.state.resource.status,
				visible: this.state.resource.visible,
				page: props.page,				
			}
		}, () => {
			this.getFilteredResults();
		});
	}

	getFilteredResults = () => {
		axios.post(API_URL+'/filter', {
			keyword: this.state.resource.keyword,
			type: this.state.resource.type,
			organisation_title: this.state.resource.organisation_title,
			support_send: this.state.resource.support_send,
			keystages: this.state.resource.keystages,
			postcode: this.state.resource.postcode,
			artform: this.state.resource.artform,
			sort: this.state.resource.sort,
			distance: this.state.resource.distance,
			status: this.state.resource.status,
			free: this.state.resource.free,
			visible: this.state.resource.visible,
			page: this.state.resource.page,
		})
		.then(response => {
			const resources = response.data.data;
			const pagination = response.data.meta.pagination;

			if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
				this.setState({
					resources: resources,
					loading: false,
					pagination: pagination,
				}, () => {
					const href = window.location.href;
		            let url = href + '?page=' + this.state.resource.page;
					
					if (window.location.search.indexOf('page') > 0) {
						const page = this.state.resource.page;
						url = '?page=' + page;
					}

					this.saveState(url, this.state.resources, this.state.resource.page, this.state.pagination);
				});
			} else {
				this.setState({
					resources: resources,
					loading: false,
					pagination: pagination,
				});				
			}
		});
	};

	handleSortOrderChange = (e, sort) => {
		this.setState(
			prevState => ({
				...prevState,
				resource: {
					...prevState.resource,
					sort: sort
				}
			}), () => {
				this.getFilteredResults();
				this.scrollInto.current.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}
		)
	}


	handlePageChange = (pageNumber, ref) => {
		this.setState(
			prevState => ({
				...prevState,
				resource: {
					...prevState.resource,
					page: pageNumber
				},
				pagination: {
					...prevState.pagination,
					current_page: pageNumber
				}
			}), () => {
				this.getFilteredResults();
				this.scrollInto.current.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}
		)
	}

	saveState(url, container, page, pagination) {
		window.history.pushState({
			path: url,
			filtersHtml: container,
			page: page,
			pagination: pagination
		}, 'Event list', url);
	}

	renderLoadmore() {
		if (this.state.pagination.total_pages > this.state.pagination.current_page || this.state.init_load_more) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-1 py-md-4">						
						<button onClick={this.onLoadMore} className="btn btn-primary btn-lg">
							Load More <div className="loading-spinner">
							<BarLoader
								color={'#FFF'}
								loading={this.state.loading}
							/>
						</div></button>
					</div>
				</div>
			);
		}
	};

	renderResults() {
		if (this.state.resources.length) {
			return (
				this.state.resources.map(resource => 
					<ResourceItem key={resource.id} resource={resource}/>
				)
			);
		}

		if (!this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<h1>No results found</h1>
					</div>
				</div>
			);			
		}
	}

	renderLoadFinalResult() {
		if (this.state.loading) {
			return (
				<div className="container py-10">
					<div className="d-flex justify-content-center align-items-center py-4">
						<div className="loading-spinner">
							<ClipLoader
								color={'#28A2FB'}
								size={100}
								loading={true}
							/>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<Fragment>
						{this.renderSorting()}
					<section id="tabResults" className="tab-results" ref={this.scrollInto}>
						{ this.renderPagination() }
						{ this.renderResults() }
						{ this.renderPagination() }
					</section>
				</Fragment>
			);
		}
	}

	renderPagination() {
		const pagination = this.state.pagination;

		if (pagination.total_pages > 1) {
			return (
				<section className="bg-grey">
					<div className="container">
						<nav aria-label="Pagination nav">
							<Scrollbars autoHide autoHeight>
								<Pagination 
									activePage={pagination.current_page}
									itemsCountPerPage={pagination.per_page}
									totalItemsCount={pagination.total}
									pageRangeDisplayed={pagination.total_pages}
									onChange={this.handlePageChange}
									itemClass="page-item"
									linkClass="page-link"
									firstPageText={<span className="fa fa-angle-double-left"></span>}
									lastPageText={<span className="fa fa-angle-double-right"></span>}
									nextPageText={<span className="fa fa-angle-right"></span>}
									prevPageText={<span className="fa fa-angle-left"></span>}
								/>
							</Scrollbars>
						</nav>
					</div>
				</section>
			)			
		}
	}

	renderNumberResults() {
		const results = this.state.pagination;

		return (
			<span>
				{results.total} resources found
			</span>
		)
	}

	renderSorting() {
		return (
			<section className="bg-grey border-bottom">
				<div className="container py-2">
					<div className="row">
						<div className="col">
							<label className="pr-2">SORT</label>
							<button className={'btn btn-sort mr-1' + ((this.state.resource.sort === 'submitted') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'submitted')}>MOST RECENT</button>
							
							<button className={'btn btn-sort mr-1' + ((this.state.resource.sort === 'title') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'title')}>A-Z</button>
							<button className={'btn btn-sort mr-1' + ((this.state.resource.sort === 'random') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'random')}>RANDOM</button>
							<PublicTagLinks activity_type="resources" tag=""/>
							{this.renderNumberResults()}
						</div>

					</div>
				</div>
			</section>
		);
	}


	render() {
		return (
			<Fragment>
				<ResourceFilter 
					ref={this.resourceFilter}
					onClearFilter={this.onClearFilter} 
					onFilteredResults={this.onFilteredResults}
					support_send={this.props.support_send}
					free={this.props.free}
				/>

				{ this.renderLoadFinalResult() }
			</Fragment>
		)
	}
}

export default ResourceList;